module.exports = __webpack_public_path__ + "static/media/dataviz_results.4bd5a6df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dataviz_results.svg
// module id = 140
// module chunks = 0